import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LoginForm from '../components/LoginForm';

const SignIn = () => {
    useEffect(() => {
      document.body.classList.add('page-home'); 
      return () => {
        document.body.classList.remove('page-home');
      };
    }, []);

  return (
    <React.Fragment>
      <Header />
      <LoginForm />
      <Footer />
    </React.Fragment>
  );
};

export default SignIn;